import './gray-box.scss';

/**
 * version    1.0
 * class      <type> (GrayBox)
 * classdesc  Gray Box: gray box list that contain title and link
 */
export class GrayBox {}
